import moment, { Moment } from 'moment-timezone';
import PersonData from '@/ts/PersonData';
import AttachmentData from '@/ts/AttachmentData';
import { ImageMetaData } from '@/ts/HococoInterfaces';

export default class MessageData {
    public id: number;
    public authorId: number;
    public message: string = '';
    public time: moment.Moment;
    public unread: boolean;
    public bySelf: boolean;
    public attachmentGUID: string | null;
    public originalFilename: string | null;
    public attachment: AttachmentData | null;
    public imageMetadata: ImageMetaData | null;
    public actionType: string | null;
    public actionTarget: number | null;

    constructor(
        id: number,
        authorId: number,
        bySelf: boolean,
        time: moment.Moment,
        message: string,
        unread: boolean,
        attachmentGUID: string | null,
        originalFilename: string | null,
        actionType: string | null,
        actionTarget: number | null,
        imageMetaData: ImageMetaData | null = null,
    ) {
        this.id = id;
        this.authorId = authorId;
        this.bySelf = bySelf;
        this.time = time;
        this.message = message;
        this.unread = unread;
        this.attachmentGUID = attachmentGUID;
        this.originalFilename = originalFilename;
        this.actionType = actionType;
        this.actionTarget = actionTarget;
        this.imageMetadata = imageMetaData;
    }

    get localTime(): moment.Moment {
        return this.time.local();
    }

    get sortingCriterion(): number {
        return parseFloat(this.localTime.format('X'));
    }

    get isAction(): boolean {
        return this.actionType !== null;
    }    

    public shortTime(): string {
        return this.localTime.toString();
    }

    public toString(): string {
        return this.message;
    }

    public getSearchableText(): string {
        let searchString = '';
        
        if (this.message !== null && this.message !== '') {
            searchString += this.message.toString();
        }
        
        return searchString.toLowerCase();
    }
 
    public hasMetaData() {
        return (this.imageMetadata !== null);
    }

    public setImageMetadata(imageMetaData: ImageMetaData) {
        this.imageMetadata = imageMetaData;
    }
}
